import React, {useEffect, useState} from "react";
import {FormControl, InputLabel, MenuItem, Select, Stack, TextField} from "@mui/material";
import {TopicRepository} from "../../../../../repositories/TopicRepository";
import {UserInputSettings} from "./components/user-input-settings";
import {fieldSx} from "../editMenuStyles";

export const RecommendationSettings = ({node, setNode, onUpdate, project, onChangeData}) => {
    const [topics, setTopics] = useState([]);

    useEffect(() => {
        TopicRepository.getAll().then(response => setTopics(response.data)).catch(err => console.log(err));
    }, []);

    const setData = (key, value) => setNode(prev => ({...prev, data: {...prev.data, [key]: value}}));

    return (
        <>
            <Stack direction="row" gap={1}>
                <FormControl size="small" sx={fieldSx}>
                    <InputLabel id="recommendation-method-label">Api Method</InputLabel>
                    <Select
                        labelId="recommendation-method-label"
                        value={node?.data?.recommendation_method || "none"}
                        label="Api Method"
                        onChange={(e) => setData("recommendation_method", e.target.value === "none" ? null : e.target.value)}
                        onBlur={() => onUpdate(node)}
                    >
                        <MenuItem value="none"><em>None</em></MenuItem>
                        <MenuItem value="GET">GET</MenuItem>
                        <MenuItem value="POST">POST</MenuItem>
                        <MenuItem value="PUT">PUT</MenuItem>
                        <MenuItem value="PATCH">PATCH</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    label="Api URL"
                    size="small"
                    value={node?.data?.recommendation_api}
                    InputLabelProps={{shrink: true}}
                    sx={{flex: 1, ...fieldSx}}
                    onChange={(e) => setData("recommendation_api", e.target.value)}
                    onBlur={() => onUpdate(node)}
                />
            </Stack>

            <FormControl size="small" fullWidth sx={fieldSx}>
                <InputLabel id="recommendation-topic-label">Topic</InputLabel>
                <Select
                    labelId="recommendation-topic-label"
                    label="Topic"
                    value={node?.data?.topic_id === null ? "none" : node?.data?.topic_id}
                    onChange={e => setData("topic_id", +e.target.value || null)}
                    onBlur={() => onUpdate(node)}
                >
                    <MenuItem value="none"><em>None</em></MenuItem>
                    {topics?.filter(item => (item?.org_id || item?.organization?.id) == project?.settings?.organization)
                        ?.map(item => <MenuItem key={item?.id} value={item?.id}>{item?.name}</MenuItem>)}
                </Select>
            </FormControl>

            <TextField
                label="Entity Type"
                size="small"
                value={node?.data?.entity_type}
                InputLabelProps={{shrink: true}}
                sx={fieldSx}
                onChange={(e) => setData("entity_type", e.target.value)}
                onBlur={() => onUpdate(node)}
            />
            <TextField
                label="History Buffer"
                size="small"
                value={node?.data?.conversation_buffer_window}
                InputLabelProps={{shrink: true}}
                sx={fieldSx}
                onChange={(e) => setData("conversation_buffer_window", e.target.value)}
                onBlur={() => onUpdate(node)}
            />

            <UserInputSettings node={node} onUpdate={onUpdate} onChangeData={onChangeData}/>
        </>
    );
};
